module.exports = __webpack_public_path__ + "img/afiliate.b8459b53.jpg";